var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.716 16.908L5.01 11.2a1.228 1.228 0 010-1.735l5.707-5.706a1.227 1.227 0 011.735 0l5.707 5.706c.478.48.478 1.257 0 1.735l-5.707 5.708c-.48.479-1.256.479-1.735 0z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M10.711 8.014v4.841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.368 10.233H10.71V7.812h1.657c.532 0 .964.433.964.966v.49a.965.965 0 01-.964.965z",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M11.583 17.317v5.289"
  }))));
}
export default SvgParking;